import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { useSDK } from '../../../app';
import { styled } from '../../../styled';
import { useSanitize } from '../../../utils/useSanitize';
import { GratitudeButton } from '../gratitudeButton';
import { msgs } from './msgs';

type Interface = { className: string };

const DefaultMessage = styled(({ className }: { className: string }): ReactElement => {
	const { formatMessage } = useIntl();
	return (
		<div className={className}>
			<div className="offline-form__text_bold">{formatMessage(msgs.applicationAccepted)}</div>
			<div>{formatMessage(msgs.thanksForApplication)}</div>
		</div>
	);
})(css`
	& .offline-form__text_bold {
		font-weight: bold;
	}
`);

const Component = observer(({ className }: Interface): ReactElement => {
	const { uiStateStore, welcomeDataStore } = useSDK();
	const { formatMessage } = useIntl();
	const containerHtml = useSanitize(welcomeDataStore.data?.showcase.offlineFormSubmitText);

	return (
		<div className={className}>
			{containerHtml ? <span dangerouslySetInnerHTML={containerHtml} /> : <DefaultMessage />}
			<GratitudeButton onClick={uiStateStore.closeOfflineChatGratitude}>
				{formatMessage(msgs.openChat)}
			</GratitudeButton>
		</div>
	);
});

const OfflineChatGratitudeContainer = styled(Component)(css`
	font-size: 16px;
	padding: 0 18px;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	overflow: hidden;
	font-weight: 300;

	& > span {
		text-align: center;
		margin-bottom: 10px;
		line-height: 30px;
	}
`);

export { OfflineChatGratitudeContainer };
